import React, { useMemo, useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import Currency from '@xanadu/ui-shared/components/Currency';
import { roundDownSmallValue } from '@xanadu/ui-shared/utils/numbers';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { isFuturesOrPredictionsProduct } from '@xanadu/ui-shared/modules/application/selectors';
import DotLoader from '../../DotLoader';

import { BONUS_TYPES } from '../../../constants';
import styles from './BonusDisplay.module.scss';

const BonusDisplay = ({
  bonusAmount,
  bonusFreeFunds,
  freeSpins,
  balanceLoading,
  t,
  isFuturesOrPredictions,
}) => {
  const bonusBalanceClass = (type) => classNames({
    [styles.balanceContainer]: true,
    [styles['balanceContainer--free-bets']]: type === BONUS_TYPES.FREE_BETS,
    [styles['balanceContainer--bonus-title']]: type === BONUS_TYPES.CASINO_BONUS || type === BONUS_TYPES.FREE_SPINS,
  });

  const getBonusInfo = (bonusData) => (
    <div className={bonusBalanceClass(bonusData.type)}>
      {balanceLoading ? (
        <DotLoader yellow small />
      ) : (
        <Fragment>
          <div className={styles.balanceTitle}>{t(bonusData.title)}:</div>
          <div className={styles.balanceValue}>
            {bonusData.type === BONUS_TYPES.FREE_SPINS ? (
              <span>{`x${bonusData.amount}`}</span>
            ) : (
              <Currency value={roundDownSmallValue(bonusData.amount)} round="floor" />

            )}
          </div>
        </Fragment>
      )}
    </div>
  );

  const bonusItems = useMemo(() => {
    const items = [
      { type: BONUS_TYPES.CASINO_BONUS, title: 'Casino Bonus', amount: bonusAmount },
      { type: BONUS_TYPES.FREE_BETS, title: 'Bonus', amount: bonusFreeFunds },
      { type: BONUS_TYPES.FREE_SPINS, title: 'Free Spins', amount: freeSpins },
    ];

    return items
      .filter(item => item.amount)
      .filter(({ type }) =>
        (isFuturesOrPredictions ? type === BONUS_TYPES.FREE_BETS : true)
      );
  }, [bonusAmount, bonusFreeFunds, freeSpins]);

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (bonusItems.length <= 1 || isFuturesOrPredictions) return undefined;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % bonusItems.length);
    }, 8000);

    return () => clearInterval(interval);
  }, [bonusItems.length, isFuturesOrPredictions]);

  if (bonusItems.length === 0) {
    return null;
  }

  return (
    <div>
      {getBonusInfo(bonusItems[currentIndex])}
    </div>
  );
};

BonusDisplay.propTypes = ({
  bonusAmount: PropTypes.number,
  bonusFreeFunds: PropTypes.number,
  freeSpins: PropTypes.string,
  balanceLoading: PropTypes.bool,
  t: PropTypes.func.isRequired,
  isFuturesOrPredictions: PropTypes.bool.isRequired,
});

function mapStateToProps(state) {
  return {
    isFuturesOrPredictions: isFuturesOrPredictionsProduct(state),
  };
}

export default connect(mapStateToProps)(BonusDisplay);
